'use client'

import { useEffect } from 'react'
import { useSearchParams, useRouter } from 'next/navigation'
import toast from 'react-hot-toast'

export function LogoutToast() {
  const searchParams = useSearchParams()
  const router = useRouter()

  useEffect(() => {
    if (searchParams.get('logout') === 'success') {
      toast.success('Logged out successfully')
      // Remove the query param from URL without reloading
      router.replace(window.location.pathname)
    }
  }, [searchParams, router])

  return null
}
